import styled from 'styled-components'

export const Details = styled.div<{ $maxHeight?: string }>`
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    max-height: ${(p) => (p.$maxHeight ? p.$maxHeight : '100%')};
    flex: 1;
`

export const DetailsHeader = styled.div`
    color: ${(p) => p.theme.colors.darkGrey};
    font-size: 24px;
`
